var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApp } from "vue";
import { createPinia } from "pinia";
import { useCartStore } from "./store";
import CartApp from "./CartApp.vue";
import CartEventBus from "./CartEventBus";
import useCartApi from "./api";
import { extractAppData, extractData } from "../../utils";
import { updateCartFromHTML } from "../../components/cart";
export default function initCartApp() {
    var _this = this;
    var cartEl = document.getElementById('cartApp');
    var cartDataEl = document.getElementById('cartData');
    if (!cartEl || !cartDataEl) {
        return;
    }
    var api = useCartApi();
    var pinia = createPinia();
    var store = useCartStore(pinia);
    var initialData = extractData(cartDataEl);
    var appData = extractAppData(cartEl);
    var giftNumbers = appData.rules;
    var actionPool = getActionPool(CartEventBus, initialData);
    store.setGiftLimits(appData.minOrderSum, appData.vipMinOrderSum);
    createApp(CartApp, {
        atomizersAvailable: appData === null || appData === void 0 ? void 0 : appData.atomizersAvailable
    }).use(pinia).mount(cartEl);
    CartEventBus.on('cart:update', updateCart);
    CartEventBus.on('cart:refresh', function () { return actionPool.refreshCart(); });
    CartEventBus.on('coupons:add', function (code) { return store.addCoupon(code) && actionPool.addCoupon(code); });
    CartEventBus.on('coupons:remove', function (code) { return store.removeCoupon(code) && actionPool.removeCoupon(code); });
    CartEventBus.on('gifts:get_giftable', function () { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = (_a = store).setGiftableProducts;
                return [4 /*yield*/, api.getGiftable()];
            case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
        }
    }); }); });
    CartEventBus.on('gifts:add', function (id) { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = store.addGift(id);
                if (!_a) return [3 /*break*/, 2];
                _b = updateGifts;
                return [4 /*yield*/, api.addGift(id)];
            case 1:
                _a = _b.apply(void 0, [_c.sent()]);
                _c.label = 2;
            case 2: return [2 /*return*/, _a];
        }
    }); }); });
    CartEventBus.on('gifts:remove', function (id) { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = store.removeGift(id);
                if (!_a) return [3 /*break*/, 2];
                _b = updateGifts;
                return [4 /*yield*/, api.removeGift(id)];
            case 1:
                _a = _b.apply(void 0, [_c.sent()]);
                _c.label = 2;
            case 2: return [2 /*return*/, _a];
        }
    }); }); });
    CartEventBus.on('products:delete', deleteProduct);
    CartEventBus.on('products:quantity', updateProductQuantity);
    updateCart(initialData.result, true);
    CartEventBus.emit('loader:show');
    function updateProductQuantity(_a) {
        var product = _a.product, quantity = _a.quantity, oldQuantity = _a.oldQuantity;
        var diffQuantity = quantity - oldQuantity;
        var storeProduct = store.getProduct(product.cartItemId);
        if (storeProduct) {
            storeProduct.quantity = quantity;
        }
        store.setTotals(store.totalSum + product.price * diffQuantity, store.totalDiscount + product.discountAmount * diffQuantity);
        store.setAvailable(computeGiftsNumber(store.bottles));
        actionPool.changeQuantity(product.cartItemId, quantity, oldQuantity);
    }
    function computeGiftsNumber(bottles) {
        var _a, _b;
        return (_b = (_a = giftNumbers.find(function (gift) { return bottles >= gift.min && (gift.max ? bottles <= gift.max : true); })) === null || _a === void 0 ? void 0 : _a.gifts) !== null && _b !== void 0 ? _b : 0;
    }
    function deleteProduct(product) {
        store.removeProduct(product.cartItemId);
        store.setTotals(store.totalSum - product.sum, store.totalDiscount - product.fullDiscount);
        store.setAvailable(computeGiftsNumber(store.bottles));
        actionPool.deleteItem(product.cartItemId);
    }
    function updateCart(data, initial) {
        if (initial === void 0) { initial = false; }
        store.setCoupons(data.COUPON_LIST.map(function (coupon) { return ({
            status: coupon.CHECK_CODE_TEXT.join('\r'),
            code: coupon.COUPON,
            valid: coupon.CHECK_CODE === 0,
            amount: coupon.AMOUNT,
        }); }));
        store.setProducts(data.BASKET_ITEM_RENDER_DATA);
        if (data.TOTAL_RENDER_DATA) {
            store.setTotals(data.TOTAL_RENDER_DATA.SUM, data.TOTAL_RENDER_DATA.TOTAL_DISCOUNT);
        }
        updateGifts(data.gifts_data);
        updateCartFromHTML(data.cart_block);
        if (!initial) {
            store.initialized = true;
        }
        data.WARNING_MESSAGE.forEach(function (warning) { return CartEventBus.emit('warning:show', warning); });
        actionPool.setRefreshStatus(true);
    }
    function updateGifts(data) {
        if (!data) {
            return;
        }
        store.setGifts(data.gifts);
        store.setAvailable(data.available);
    }
}
function getActionPool(eventBus, initialData) {
    BX.Sale.BasketComponent.init(initialData, eventBus);
    return BX.Sale.BasketComponent.actionPool;
}
